import React, { useEffect, useState } from 'react';
import './Main.css';
// import "../../../src/App.css";
import { Carousel } from 'react-bootstrap';
import Appconfig from '../../config/config'
import Helper from '../../helper';
import { useDispatch, useSelector } from 'react-redux';
import { getBanner } from '../../redux/slice/banner/bannerSlice';
import axios from 'axios';

const Main = (props) => {
  const userInfo = Helper();
  const [banner, setbanners] = useState();


  function getBanner() {
    var data = JSON.stringify({
      site_code: "P1001",
    });

    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}banner/getDashboardBannerBySiteCode`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,

    };

    // console.log("data getting", config);



    axios(config)
      .then(function (response) {
        if (response.data.result == 0) {
        } else {
          // setBalance(response.data.resultData?.balance)
          // setExposure(response.data.resultData?.exposure)
          // console.log('banner response', response?.data?.resultData);
          setbanners(response?.data?.resultData);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  useEffect(() => {
    getBanner();
    // if (userInfo) {

    //   useDispatch(getBanner({
    //     user_id: userInfo?.master_id,
    //   }));
    // }
  }, [userInfo])


  return (
    // <div className={`border-b-4 border-black
    //     ${userInfo ? 'ml-0 lg:ml-[15%] h-[200px]' : 'ml-0'} 
    //     md:h-[600px] sm:h-[200px]
    //   `}
    // >
    //   {
    //     banner && banner?.length > 0 &&
    //     <>
    //       <Carousel>
    //         {banner && banner?.length > 0 && banner.map((ban, index) => (
    //           <Carousel.Item interval={1000} key={ban?.id}>
    //             <img src={`${Appconfig.apiUrl}banner/${ban.image_name}`} className={` banner-images w-full object-fit  md:h-[600px] ${userInfo ? 'h-[200px]' : 'ml-0'}`} alt="..." />
    //           </Carousel.Item>
    //         ))}
    //       </Carousel>
    //     </>

    //   }

    // </div>
    <div
      className={
        userInfo
          ? "border-b-4 border-black ml-0 h-[146px] sm:h-[200px] md:h-[200px]"
          : "border-b-4 border-black ml-0 h-[146px] sm:h-[200px] md:h-[600px]"
      }
    >
      {banner && banner.length > 0 && (
        <Carousel>
          {banner.map((ban, index) => (
            <Carousel.Item interval={1000} key={ban?.id}>
              <img
                src={`${Appconfig.apiUrl}banner/${ban.image_name}`}
                className={
                  userInfo
                    ? "banner-images w-full object-fit h-[146px] sm:h-[200px] md:h-[200px]"
                    : "banner-images w-full object-fit h-[146px] sm:h-[200px] md:h-[600px]"
                }
                alt="..."
              />
            </Carousel.Item>
          ))}
        </Carousel>
      )}
    </div>
  );
};
export default Main;